"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _some = _interopRequireDefault(require("lodash/some"));
var _settings = require("../settings");
var shouldHideOption = function shouldHideOption(option, options, choices) {
  var _getSettings = (0, _settings.getSettings)(),
    hiddenOptions = _getSettings.hiddenOptions;
  if (option.isActive === false || option.choices.length === 0 || (0, _some["default"])(hiddenOptions, function (optionId) {
    return optionId === option.id;
  })) {
    return true;
  }
  if (option.isDependent) {
    var parentChoice = choices[option.parentChoiceId];
    if (!parentChoice.isSelected) {
      return true;
    }
    return shouldHideOption(options[parentChoice.optionId], options, choices, hiddenOptions);
  }
  return false;
};
var _default = exports["default"] = shouldHideOption;
//# sourceMappingURL=shouldHideOption.js.map